import { API } from "aws-amplify";
import { AxiosError } from "axios";
import { useQuery, useQueryClient } from "react-query";
import { IRegistryData } from "../../../../models/RegistryData";
import { APIEndpoints, QueryKeys } from "../../config";

const makeApiRequest = (cohortId?: string): Promise<IRegistryData> => {
  const qParams = {};
  return API.get(
    APIEndpoints.private,
    `/api/v1/cohorts/${cohortId}/data`,
    qParams
  );
};

interface IProps {
  cohortId?: string;
}

export const useReadCohortData = ({ cohortId }: IProps) => {
  const queryClient = useQueryClient();

  if (!cohortId) {
    queryClient.removeQueries(QueryKeys.cohortData(), { exact: false });
  }

  return useQuery<IRegistryData, AxiosError>(
    QueryKeys.cohortDataDetail(cohortId),
    () => makeApiRequest(cohortId),
    {
      retry: 0,
      enabled: !!cohortId,
      staleTime: 60 * 0.25,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
    }
  );
};
